import React, { Component } from "react";
import { Navbar, NavDropdown, Form, FormLabel } from "react-bootstrap";
import SettingsIcon from "@material-ui/icons/Settings";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { api_url_estabelecimentos_image } from "../providers/api";
import { getUser, setUser, logout } from "../services/Auth";
import { MudarStatusEstabelecimento } from "../providers/EstabelecimentoProvider";
import headerLogo from "../assets/logotipo-ifeira.svg";
import Switch from "./Switch";

export default class Header extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      status: null,
      user: null,
    };
  }

  async handleLogout() {
    logout();
    await window.location.reload();
  }

  mudarStatus = async (status) => {
    const user = this.state.user;
    const res = await MudarStatusEstabelecimento(status ? "Aberto" : "Fechado");
    user.estabelecimento = res;
    await setUser(user);
    this.setState({
      status: status,
    });
  };

  async componentDidMount() {
    const user = await getUser();
    this.setState({
      status: user.estabelecimento.status === "Aberto",
      user,
    });
  }

  render() {
    return (
      <Navbar expand="lg" style={{ backgroundColor: "white !important" }}>
        <Navbar.Brand href="#/app">
          <img
            alt=""
            src={headerLogo}
            className="d-inline-block align-top"
            width="75px"
            style={{ marginLeft: 25 }}
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse className="justify-content-end">
          {this.state.user ? (
            <>
              <img
                width={40}
                height={30}
                style={{ borderRadius: 30 }}
                alt="logo"
                src={
                  api_url_estabelecimentos_image +
                  this.state.user.estabelecimento.foto_estabelecimento
                }
              ></img>
              <Form inline>
                <FormLabel style={{ color: "#701B8C", marginLeft: 20, marginRight: 40 }}>
                  {this.state.user.estabelecimento.nome_fantasia}
                </FormLabel>
                <FormLabel style={{ color: "#701B8C" }}>
                  Status: {this.state.status ? "Aberto" : "Fechado"}
                </FormLabel>
                <Switch
                  checked={this.state.status}
                  onChange={(e) => this.mudarStatus(e.target.checked)}
                />
              </Form>
            </>
          ) : null}
          <NavDropdown title={<SettingsIcon></SettingsIcon>} id="collasible-nav-dropdown">
            <NavDropdown.Item onClick={() => this.handleLogout()}>
              <ExitToAppIcon></ExitToAppIcon>
              Sair
            </NavDropdown.Item>
          </NavDropdown>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}
